import React from "react";
import { graphql } from 'gatsby';
import BlogsList from "./blogsList";

export const BlogListQuery = graphql`query ($skip: Int!, $limit: Int!, $featuredBlogId: [Int]!, $featuredThinkingBlogsId: [Int]!) {
  PaginationPosts: allWordpressPost(
    limit: $limit
    skip: $skip
    sort: {order: DESC, fields: date}
  ) {
    edges {
      node {
        title
        featured_media {
          source_url
          alt_text
          localFile {
            childImageSharp {
              gatsbyImageData(width: 860, layout: CONSTRAINED)
            }
          }
        }
        slug
        content
        date(formatString: "DD MMMM, YYYY")
        categories {
          name
          slug
        }
        acf {
          lending_page_image {
            source_url
          }
          display_category {
            name
            slug
          }
        }
      }
    }
  }
  totalPosts: allWordpressPost {
    totalCount
  }
  allWordpressCategory {
    edges {
      node {
        count
        name
        slug
      }
    }
  }
  FeaturedBlog: allWordpressPost(filter: {wordpress_id: {in: $featuredBlogId}}) {
    edges {
      node {
        title
        featured_media {
          source_url
          alt_text
        }
        slug
        content
        date(formatString: "DD MMMM, YYYY")
        categories {
          name
          slug
        }
        acf {
          lending_page_image {
            source_url
            alt_text
          }
          display_category {
            name
            slug
          }
        }
      }
    }
  }
  FeaturedThinkingBlogs: allWordpressPost(
    filter: {wordpress_id: {in: $featuredThinkingBlogsId}}
  ) {
    edges {
      node {
        title
        featured_media {
          source_url
          alt_text
        }
        slug
        content
        date(formatString: "DD MMMM, YYYY")
        categories {
          name
          slug
        }
        acf {
          lending_page_image {
            source_url
            alt_text
          }
          display_category {
            name
            slug
          }
        }
        wordpress_id
      }
    }
  }
  allWordpressPage {
    edges {
      node {
        acf {
          cta1_button_link
          cta1_button_text
          cta1_sub_title
          cta1_title
          cta2_button_link
          cta2_button_text
          cta2_sub_title
          cta2_title
          cta1_class
          cta2_class
          cta1_image {
            source_url
          }
          cta2_image {
            source_url
          }
        }
      }
    }
  }
}
`;

const BlogPage = (props, { location }) => {
  return (
    <>
      <BlogsList data={props} location={location} category="Everything" />
    </>
  );
};

export default BlogPage;